import {CouponService} from "../resource";

const CouponModule = {
	namespaced: true,
	state: {
		datas: [],
		datas_detail: [],
		coupon_logs: [],
		logs_pagination: { total: 0, page: 1, page_size: 50 },
		currentPage : 1,
		isLoading:false,
		currentParams : {
			status: 0,
		}
	},
	mutations: {
		SET_DATA(state, data) {
			state.datas = data;
		},
		SET_DATA_DETAIL(state, data) {
			state.datas_detail = data;
		},
		SET_CURRENT_PAGE(state, data) {
			state.currentPage = data;
		},
		SET_COUPON_LOGS(state, data) {
			state.coupon_logs = data;
		},
		SET_LOGS_PAGINATION(state, data) {
			state.logs_pagination = data;
		},
	},
	actions: {
		createData({ commit, state }, data) {
			return CouponService.CouponCreate(data);
		},

		updateData({ commit, state }, data) {
			return CouponService.CouponUpdate(data.id,data.payload);
		},
		deleteData({ commit, state }, data) {
			return CouponService.CouponDelete(data);
		},

		getData({ commit, state }, data) {
			return CouponService.CouponGet(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponList(data);
				commit("SET_DATA", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA", []);
			}
		},
		async listDataDetail({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponListDetail(data);
				commit("SET_DATA_DETAIL", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA_DETAIL", []);
			}
		},
		async listDataDetailAll({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponListDetailAll(data);
				commit("SET_DATA_DETAIL", response.data != null ? response.data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA_DETAIL", []);
			}
		},

		// listDataDetailAllStrict — the same request as listDataDetailAll, but a
		// failure RETHROWS instead of being swallowed into an empty table.
		//
		// WHY A SECOND ACTION AND NOT A FLAG ON THE FIRST
		//
		// The sibling above deliberately swallows: its callers do not await it,
		// so a rejection there becomes an unhandled promise rejection. That is
		// survivable for the ordinary search, where an empty table and a failed
		// request look the same to the operator anyway.
		//
		// It is NOT survivable for §8.2's "All". That request can be refused
		// (403, caller not on coupon_event.emails) and the swallow would answer
		// the refusal with an empty table — whereupon Export writes an empty
		// spreadsheet and the operator has been told nothing at all. The caller
		// of this one awaits it and shows the refusal.
		//
		// THE ROWS ARE FROZEN, AND THAT IS NOT A MICRO-OPTIMISATION
		//
		// Vuex hands everything it commits to Vue's reactivity walker, which
		// recurses the whole structure and installs a getter/setter pair per
		// property plus a Dep object per object. Measured on a 100k-row "All"
		// response: 1.6 s of blocked main thread and +2.35 GB of heap, against
		// 18 ms and no measurable growth for the same rows frozen.
		// Object.freeze makes Vue skip the walk entirely (it checks
		// Object.isExtensible before observing), so the rows go in as plain
		// data.
		//
		// Nothing on this screen needs them reactive: the table only ever
		// REPLACES the array, never edits a row in place, and replacing the
		// array is what triggers the re-render. Frozen elements are still
		// sortable — clientPaginationMixin's sortChange reorders the array,
		// which is not a write to any element — and still serialisable, which
		// is all Export does.
		//
		// The sibling above is left alone on purpose: it serves the ordinary
		// search, which is capped at 1,000/10,000 rows.
		async listDataDetailAllStrict({ commit, state }, data) {
			try
			{
				const response = await CouponService.CouponListDetailAll(data);
				const rows = Array.isArray(response.data) ? response.data : [];
				commit("SET_DATA_DETAIL", rows.map(Object.freeze));
			}
			catch (error)
			{
				commit("SET_DATA_DETAIL", []);
				throw error;
			}
		},
		setCurrentPage({ commit, state }, data){
			console.log("SET_CURRENT_PAGE",data)
			commit("SET_CURRENT_PAGE",data)
		},
		setPlatformCurrentParams({ commit, state }, data){
			console.log("SET_CURRENT_PARAMS",data)
			commit("SET_CURRENT_PARAMS",data)
		},
		getCouponDocument({ commit, state }, data) {
            return CouponService.CouponGetDocument(data);
        },
		clearDataDetail({ commit, state }, data) {
			commit("SET_DATA_DETAIL", []);
		},

		// Clear coupon from order
		clearCouponOrder({ commit, state }, data) {
			return CouponService.CouponClearOrder(data);
		},

		// Set/bind coupon(s) to order
		setCouponOrder({ commit, state }, data) {
			return CouponService.CouponSetOrder(data);
		},

		// List coupon logs with filters
		async listCouponLogs({ commit, state }, data) {
			try {
				const response = await CouponService.CouponLogList(data);
				const responseData = (response.data && response.data.Datum) || {};
				const logs = responseData.logs || [];
				commit("SET_COUPON_LOGS", logs);
				commit("SET_LOGS_PAGINATION", {
					total: responseData.total || 0,
					page: responseData.page || 1,
					page_size: responseData.page_size || 50
				});
				return response;
			} catch (error) {
				console.log(error);
				commit("SET_COUPON_LOGS", []);
				throw error;
			}
		},

		clearCouponLogs({ commit }) {
			commit("SET_COUPON_LOGS", []);
			commit("SET_LOGS_PAGINATION", { total: 0, page: 1, page_size: 50 });
		},

	},
	getters: {
		isLoading(state) {
			return state.isLoading;
		},
		getData(state) {
			return state.datas;
		},
		getDataDetail(state) {
			return state.datas_detail;
		},
		getCurrentPage(state) {
			return state.currentPage;
		},
		getCouponLogs(state) {
			return state.coupon_logs;
		},
		getLogsPagination(state) {
			return state.logs_pagination;
		},
	},
};

export default CouponModule;